import { all } from 'redux-saga/effects'
import sagaFunc from './customerFault';
import editStationFaultSaga from './editStationFault';
import customerSuggestionSaga from './customerSuggestion';
import customerTrainFaultSaga from './trainFault';
import archiveStationFaultSaga from './archiveStationFault';
import headerSaga from './Header';
import reportSaga from './reports';
import manageUser from './manageUser';


export default function* rootSaga() {
    yield all([
        sagaFunc.customerFault,
        sagaFunc.customerFaultImage1,
        customerSuggestionSaga.customerSuggestion,
        customerTrainFaultSaga.customerTrainFaults,
        editStationFaultSaga.editStationFault,
        archiveStationFaultSaga.archiveStationFault,
        archiveStationFaultSaga.getFaultHistory,
        headerSaga.saveFeedback,
        reportSaga.getAllReport,
        reportSaga.getAllConditionOptions,
      //  reportSaga.addReport,
        reportSaga.getReportById,
        manageUser.getAllUsers,
        
    ])
}